import { Pipe, PipeTransform } from '@angular/core';
import { annotationTypeVal } from '@mhe/reader/components/material-annotations-lists/material-annotations-list.service';
import {
  MaterialDropdownState,
} from '@mhe/reader/components/material-annotations-lists/material-annotation-list.model';

@Pipe({
  name: 'filterByState',
  standalone: true,
})
export class FilterByStatePipe implements PipeTransform {
  transform(value: annotationTypeVal[], dropdownState: MaterialDropdownState): annotationTypeVal[] {
    if (dropdownState === MaterialDropdownState.ALL) {
      return value;
    }
    return value
      .filter((item) => item.annotations.some((annotation) => annotation.orphan))
      .map(item => ({
        ...item,
        annotations: item.annotations.filter(ann => Boolean(ann.orphan)),
      }));
  }
}
